(() => {
  const TARGET = '#2F3B27';
  const HOVER = '#273220';
  const ACTIVE = '#222B1C';

  const isCollectionPage = () =>
    document.body.classList.contains('template-collection') ||
    document.documentElement.classList.contains('template-collection') ||
    /^\/collections(?:\/|$)/.test(location.pathname);

  const parseRgb = (value) => {
    if (!value || value === 'transparent') return null;
    const m = value.match(/rgba?\(\s*([0-9.]+)\s*,\s*([0-9.]+)\s*,\s*([0-9.]+)(?:\s*,\s*([0-9.]+))?\s*\)/i);
    if (!m) return null;
    return {
      r: Number(m[1]),
      g: Number(m[2]),
      b: Number(m[3]),
      a: m[4] === undefined ? 1 : Number(m[4])
    };
  };

  const isBlackish = (rgb) => {
    if (!rgb || rgb.a < 0.7) return false;
    return rgb.r <= 48 && rgb.g <= 48 && rgb.b <= 48;
  };

  const isVisible = (el) => {
    if (!(el instanceof HTMLElement)) return false;
    const style = getComputedStyle(el);
    if (style.display === 'none' || style.visibility === 'hidden') return false;
    const r = el.getBoundingClientRect();
    return r.width >= 12 && r.height >= 12;
  };

  const isButtonLike = (el) =>
    el.matches('button, a, .button, .btn, [role="button"], input[type="submit"], input[type="button"]');

  const bindStates = (el) => {
    if (el.dataset.eliznaCollectionGreenBound === '1') return;

    el.addEventListener('mouseenter', () => {
      if (el.dataset.eliznaCollectionGreen === '1') {
        el.style.setProperty('background-color', HOVER, 'important');
        el.style.setProperty('border-color', HOVER, 'important');
      }
    });

    el.addEventListener('mouseleave', () => {
      if (el.dataset.eliznaCollectionGreen === '1') {
        el.style.setProperty('background-color', TARGET, 'important');
        el.style.setProperty('border-color', TARGET, 'important');
      }
    });

    el.addEventListener('mousedown', () => {
      if (el.dataset.eliznaCollectionGreen === '1') {
        el.style.setProperty('background-color', ACTIVE, 'important');
        el.style.setProperty('border-color', ACTIVE, 'important');
      }
    });

    el.addEventListener('mouseup', () => {
      if (el.dataset.eliznaCollectionGreen === '1') {
        el.style.setProperty('background-color', HOVER, 'important');
        el.style.setProperty('border-color', HOVER, 'important');
      }
    });

    el.dataset.eliznaCollectionGreenBound = '1';
  };

  const paint = (el) => {
    if (!isVisible(el)) return;
    if (el.matches('img, picture, video, canvas, svg, iframe')) return;

    const style = getComputedStyle(el);
    const bg = parseRgb(style.backgroundColor);
    if (!isBlackish(bg)) return;

    const rect = el.getBoundingClientRect();
    const area = rect.width * rect.height;

    const announcementLike =
      el.matches('.announcement-bar, [class*="announcement"], .top-bar, [class*="top-bar"]') ||
      (rect.width >= window.innerWidth * 0.75 && rect.height <= 90);

    const buttonLike =
      isButtonLike(el) &&
      area >= 900 &&
      rect.height <= 120;

    const sectionLike =
      area >= 45000 &&
      (
        el.matches('section, article, [class*="section"], [class*="collection"]') ||
        rect.width >= window.innerWidth * 0.45
      );

    if (!announcementLike && !buttonLike && !sectionLike) return;

    el.style.setProperty('background-color', TARGET, 'important');

    if (
      style.backgroundImage &&
      style.backgroundImage !== 'none' &&
      !/url\(/i.test(style.backgroundImage)
    ) {
      el.style.setProperty('background-image', 'none', 'important');
    }

    if (buttonLike || announcementLike) {
      el.style.setProperty('border-color', TARGET, 'important');
    }

    el.dataset.eliznaCollectionGreen = '1';

    if (buttonLike) bindStates(el);
  };

  const scan = (scope = document) => {
    if (!isCollectionPage()) return;

    const root = scope === document ? document.body : scope;
    if (!root?.querySelectorAll) return;

    paint(root);
    root.querySelectorAll('*').forEach(paint);
  };

  const init = () => {
    if (!isCollectionPage()) return;

    scan();

    const observer = new MutationObserver((mutations) => {
      let needsScan = false;

      for (const mutation of mutations) {
        if (mutation.addedNodes?.length) {
          needsScan = true;
          break;
        }
      }

      if (needsScan) requestAnimationFrame(() => scan());
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true
    });

    window.addEventListener('load', () => scan(), { once: true });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', (event) => {
    requestAnimationFrame(() => scan(event.target));
  });
})();
